/** 控制台大模型：移动端跳转 H5（与 Layout 退出登录跳转一致，使用 TEMPLATE_M_URL） */

export function isLmMobileUserAgent() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

export function isLmMobileViewport() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 768px)").matches;
}

/** 布局样式用：手机 UA 或窄屏视口 */
export function isLmMobileClient() {
  return isLmMobileUserAgent() || isLmMobileViewport();
}

export function getLmMobileAigcCreateUrl(mobileUrl) {
  const base = String(mobileUrl || process.env.TEMPLATE_M_URL || "")
    .trim()
    .replace(/\/+$/, "");
  if (!base) return "";
  return `${base}/#/aigc/create`;
}

/** 仅手机浏览器跳转 H5 创作页；PC 窄屏不跳转 @returns {boolean} 是否已发起跳转 */
export function redirectToLmMobileAigcCreate(mobileUrl) {
  if (!isLmMobileUserAgent()) return false;
  const url = getLmMobileAigcCreateUrl(mobileUrl);
  if (!url) return false;
  window.location.href = url;
  return true;
}



// WEBPACK FOOTER //
// ./src/views/lmMobileNavigate.js